import styled from 'styled-components';
export const TableRowContainerStyled = styled.div `
  display: flex;
  flex-direction: row;
`;
export const TableRowCellBaseStyled = styled.div `
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  height: auto;
  width: ${({ width }) => `${width}px`};
`;
//# sourceMappingURL=styled.js.map